module.exports = __webpack_public_path__ + "media/images/2024-25_pcv2_sp-5e291319a69fc0c3c5a2a18a840de4cf.png";